import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../modules/shared/shared.module';
import { FormInputErrorComponent } from './form-input-error.component';

@NgModule({
  declarations: [
    FormInputErrorComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [
    FormInputErrorComponent
  ]
})
export class FormInputErrorModule { }
